import { Action } from '@ngrx/store';

export enum NewProductFilePageActionTypes {
  SelectFollow = '[NewProductFilePage] Select follow',
  UploadFile = '[NewProductFilePage] Upload file',
  UploadFileSuccess = '[NewProductFilePage] Upload file success',
  UploadFileFail = '[NewProductFilePage] Upload file fail',
  ProcessFile = '[NewProductFilePage] Process file',
  ProcessFileUpdate = '[NewProductFilePage] Process file update',
  ProcessFileSuccess = '[NewProductFilePage] Process file success',
  ProcessFileFail = '[NewProductFilePage] Confirm file fail',
  ConfirmFileUpdate = '[NewProductFilePage] Confirm file update',
  ConfirmFileSuccess = '[NewProductFilePage] Confirm file success',
  ConfirmFileFail = '[NewProductFilePage] Process file fail',
  GetUploadLink = '[NewProductFilePage] GetUploadLink',
  GetUploadLinkSuccess = '[NewProductFilePage] GetUploadLink success',
  GetUploadLinkFail = '[NewProductFilePage] GetUploadLink fail',
  NotifyFileUpload = '[NewProductFilePage] Notify file upload',
  ImportProducts = '[NewProductFilePage] Import products',
  ImportProductsSuccess = '[NewProductFilePage] Import products success',
  ImportProductsFail = '[NewProductFilePage] Import products fail',
  CancelImportProducts = '[NewProductFilePage] Import products cancelled',
  CloseConfirmation = '[NewProductFilePage] CloseConfirmation',
  GenerateBook = '[NewProductFilePage] Generate book',
  GenerateBookUpdate = '[NewProductFilePage] Generate book update',
  GenerateBookFail = '[NewProductFilePage] Generate book fail',
  GenerateBookSuccess = '[NewProductFilePage] Generate book success',
  DownloadBook = '[NewProductFilePage] Download book',
  DownloadBookSuccess = '[NewProductFilePage] Download book success',
  DownloadBookFail = '[NewProductFilePage] Download book fail',
  GetImplantationLink = '[NewProductFilePage] Get implantation link',
  GetImplantationLinkFail = '[NewProductFilePage] Get implantation link fail',
  UploadImplantation = '[NewProductFilePage] Upload implantation',
  UploadImplantationSuccess = '[NewProductFilePage] Upload implantation success',
  UploadImplantationFail = '[NewProductFilePage] Upload implantation fail',
  Notify = '[NewProductFilePage] Notify implantation upload',
  UploadProcessUpdate = '[NewProductFilePage] Upload implantation precess update',
  UploadProcessSuccess = '[NewProductFilePage] Upload implantation precess success',
  UploadProcessFail = '[NewProductFilePage] Upload implantation precess fail',
  ExportGroup = '[NewProductFilePage] Export group',
  ExportGroupSuccess = '[NewProductFilePage] Export group success',
  ExportGroupUpdate = '[NewProductFilePage] Export group update',
  ExportGroupFail = '[NewProductFilePage] Export group fail',

  ImplantationProcess = '[NewProductFilePage] Process implantation',
  ImplantationProcessUpdate = '[NewProductFilePage] Process implantation update',
  ImplantationProcessSuccess = '[NewProductFilePage] Process implantation success',
  ImplantationProcessFail = '[NewProductFilePage] Process implantation fail',

  NotifyApi = '[NewProductFilePage] Notify Api',
  ClearStateProductFilePage = '[NewProductFilePage] clear state',

  GetFilesData = '[NewProductFilePage] get files data',
  GetFilesDataSuccess = '[NewProductFilePage] get files data success',
  GetFilesDataFail = '[NewProductFilePage] get files data fail'
}

export class SelectFollow implements Action {
  readonly type = NewProductFilePageActionTypes.SelectFollow;
  constructor(public id: number) {}
}

export class GetUploadLink implements Action {
  readonly type = NewProductFilePageActionTypes.GetUploadLink;
  constructor(
    public followId: number,
    public file: any,
    public uploadType: 'follow' | 'OCM' | 'image' | 'bookImage',
    public order?
  ) {}
}

export class GetUploadLinkFail implements Action {
  readonly type = NewProductFilePageActionTypes.GetUploadLinkFail;
  constructor(public error: any) {}
}

export class GetUploadLinkSuccess implements Action {
  readonly type = NewProductFilePageActionTypes.GetUploadLinkSuccess;
  constructor(public link: string, public file: any, public uploadType?: any) {}
}

export class ClearStateProductFilePage implements Action {
  readonly type = NewProductFilePageActionTypes.ClearStateProductFilePage;
  constructor(public uploadType?: any) {}
}

export class NotifyApi implements Action {
  readonly type = NewProductFilePageActionTypes.NotifyApi;
  constructor(public data?: any) {}
}

export class UploadFile implements Action {
  readonly type = NewProductFilePageActionTypes.UploadFile;
  constructor(
    public link: string,
    public file: any,
    public uploadType: 'follow' | 'image',
    public order?
  ) {}
}
export class UploadFileSuccess implements Action {
  readonly type = NewProductFilePageActionTypes.UploadFileSuccess;
  constructor(public uploadType?: any) {}
}

export class ProcessFile implements Action {
  readonly type = NewProductFilePageActionTypes.ProcessFile;
  constructor(public uploadType?: any) {}
}

export class ProcessFileUpdate implements Action {
  readonly type = NewProductFilePageActionTypes.ProcessFileUpdate;
  constructor(public job: any) {}
}

export class ProcessFileSuccess implements Action {
  readonly type = NewProductFilePageActionTypes.ProcessFileSuccess;
  constructor(public job: any, public uploadType: 'follow' | 'image') {}
}

export class ProcessFileFail implements Action {
  readonly type = NewProductFilePageActionTypes.ProcessFileFail;
  constructor(public data?: any) {}
}

export class ConfirmFileUpdate implements Action {
  readonly type = NewProductFilePageActionTypes.ConfirmFileUpdate;
  constructor(public data: any) {}
}

export class ConfirmFileSuccess implements Action {
  readonly type = NewProductFilePageActionTypes.ConfirmFileSuccess;
  constructor(public data: any) {}
}

export class CloseConfirmation implements Action {
  readonly type = NewProductFilePageActionTypes.CloseConfirmation;
  constructor(public data: any) {}
}

export class ConfirmFileFail implements Action {
  readonly type = NewProductFilePageActionTypes.ConfirmFileFail;
  constructor() {}
}

export class UploadFileFail implements Action {
  readonly type = NewProductFilePageActionTypes.UploadFileFail;
  constructor(public error: any) {}
}

export class NotifyFileUpload implements Action {
  readonly type = NewProductFilePageActionTypes.NotifyFileUpload;
  constructor(public id: string, public uploadType?: any, public order?) {}
}

export class ImportProducts implements Action {
  readonly type = NewProductFilePageActionTypes.ImportProducts;
  constructor(public FileId: string, public typeLoad?: any) {}
}

export class ImportProductsFail implements Action {
  readonly type = NewProductFilePageActionTypes.ImportProductsFail;
  constructor(public error: any) {}
}

export class ImportProductsSuccess implements Action {
  readonly type = NewProductFilePageActionTypes.ImportProductsSuccess;
  constructor(public FollowId: number) {}
}

export class CancelImportProducts implements Action {
  readonly type = NewProductFilePageActionTypes.CancelImportProducts;
  constructor(public FileId: string, public status?: string) {}
}

export class GenerateBook implements Action {
  readonly type = NewProductFilePageActionTypes.GenerateBook;
  constructor(
    public FollowId: number,
    public uniqId: any,
    public full?: any,
    public isAlternative?: boolean,
    public udnCountry?: string
  ) {}
}

export class GenerateBookUpdate implements Action {
  readonly type = NewProductFilePageActionTypes.GenerateBookUpdate;
  constructor(public data: any) {}
}

export class GenerateBookFail implements Action {
  readonly type = NewProductFilePageActionTypes.GenerateBookFail;
  constructor() {}
}

export class GenerateBookSuccess implements Action {
  readonly type = NewProductFilePageActionTypes.GenerateBookSuccess;
  constructor(public data: any) {}
}

export class DownloadBook implements Action {
  readonly type = NewProductFilePageActionTypes.DownloadBook;
  constructor(public data: any) {}
}

export class DownloadBookSuccess implements Action {
  readonly type = NewProductFilePageActionTypes.DownloadBookSuccess;
  constructor() {}
}

export class DownloadBookFail implements Action {
  readonly type = NewProductFilePageActionTypes.DownloadBookFail;
  constructor() {}
}
// export class Load implements Action {
//   readonly type = NewProductFilePageActionTypes.Load;
//   constructor() {}
// }

// export class LoadSuccess implements Action {
//   readonly type = NewProductFilePageActionTypes.LoadSuccess;
//   constructor(public products: Product[]) {}
// }

// export class LoadFail implements Action {
//   readonly type = NewProductFilePageActionTypes.LoadFail;
//   constructor(public error: any) {}
// }

// export class LoadByProduct implements Action {
//   readonly type = NewProductFilePageActionTypes.LoadByProduct;
//   constructor(public id: number) {}
// }

// export class LoadByProductSuccess implements Action {
//   readonly type = NewProductFilePageActionTypes.LoadByProductSuccess;
//   constructor(public files: File[]) {}
// }

// export class LoadByProductFail implements Action {
//   readonly type = NewProductFilePageActionTypes.LoadByProductFail;
//   constructor(public error: any) {}
// }

export class GetImplantationLink implements Action {
  readonly type = NewProductFilePageActionTypes.GetImplantationLink;
  constructor(
    public owner: any,
    public file: any,
    public uploadType: 'follow'
  ) {}
}

export class GetImplantationLinkFail implements Action {
  readonly type = NewProductFilePageActionTypes.GetImplantationLinkFail;
  constructor(public error: any) {}
}

export class UploadImplantation implements Action {
  readonly type = NewProductFilePageActionTypes.UploadImplantation;
  constructor(public link: any, public file: any) {}
}

export class UploadImplantationSuccess implements Action {
  readonly type = NewProductFilePageActionTypes.UploadImplantationSuccess;
  constructor(public data: any) {}
}

export class UploadImplantationFail implements Action {
  readonly type = NewProductFilePageActionTypes.UploadImplantationFail;
  constructor(public error: any) {}
}

// export class ProcessImplantationFile implements Action {
//   readonly type = NewProductFilePageActionTypes.ProcessImplantationFile;
//   constructor(public file: any) {}
// }

export class Notify implements Action {
  readonly type = NewProductFilePageActionTypes.Notify;
  constructor(public id: string) {}
}

export class UploadProcessUpdate implements Action {
  readonly type = NewProductFilePageActionTypes.UploadProcessUpdate;
  constructor(public data: any) {}
}

export class UploadProcessSuccess implements Action {
  readonly type = NewProductFilePageActionTypes.UploadProcessSuccess;
  constructor() {}
}

export class UploadProcessFail implements Action {
  readonly type = NewProductFilePageActionTypes.UploadProcessFail;
  constructor() {}
}

export class ExportGroup implements Action {
  readonly type = NewProductFilePageActionTypes.ExportGroup;
  constructor(public data: any) {}
}

export class ExportGroupSuccess implements Action {
  readonly type = NewProductFilePageActionTypes.ExportGroupSuccess;
  constructor(public data: any) {}
}

export class ExportGroupUpdate implements Action {
  readonly type = NewProductFilePageActionTypes.ExportGroupUpdate;
  constructor(public data: any) {}
}

export class ExportGroupFail implements Action {
  readonly type = NewProductFilePageActionTypes.ExportGroupFail;
  constructor(public error: any) {}
}

export class ImplantationProcess implements Action {
  readonly type = NewProductFilePageActionTypes.ImplantationProcess;
  constructor() {}
}

export class ImplantationProcessUpdate implements Action {
  readonly type = NewProductFilePageActionTypes.ImplantationProcessUpdate;
  constructor(public data: any) {}
}

export class ImplantationProcessSuccess implements Action {
  readonly type = NewProductFilePageActionTypes.ImplantationProcessSuccess;
  constructor() {}
}

export class ImplantationProcessFail implements Action {
  readonly type = NewProductFilePageActionTypes.ImplantationProcessFail;
  constructor(public error: any) {}
}

export class GetFilesData implements Action {
  readonly type = NewProductFilePageActionTypes.GetFilesData;
  constructor(public followId: number) {}
}

export class GetFilesDataSuccess implements Action {
  readonly type = NewProductFilePageActionTypes.GetFilesDataSuccess;
  constructor(public data: any) {}
}

export class GetFilesDataFail implements Action {
  readonly type = NewProductFilePageActionTypes.GetFilesDataFail;
  constructor() {}
}

export type NewProductFilePageActionsUnion =
  | SelectFollow
  | GetUploadLink
  | GetUploadLinkSuccess
  | GetUploadLinkFail
  | UploadFile
  | UploadFileSuccess
  | UploadFileFail
  | ProcessFile
  | ProcessFileFail
  | ProcessFileUpdate
  | ProcessFileSuccess
  | NotifyFileUpload
  | ImportProducts
  | ImportProductsSuccess
  | ImportProductsFail
  | ConfirmFileSuccess
  | ConfirmFileFail
  | ConfirmFileUpdate
  | CancelImportProducts
  | CloseConfirmation
  | GenerateBook
  | GenerateBookUpdate
  | GenerateBookFail
  | GenerateBookSuccess
  | DownloadBook
  | DownloadBookSuccess
  | DownloadBookFail
  | GetImplantationLink
  | GetImplantationLinkFail
  | UploadImplantation
  | UploadImplantationSuccess
  | UploadImplantationFail
  | ExportGroup
  | ExportGroupSuccess
  | ExportGroupUpdate
  | ExportGroupFail
  | NotifyApi
  | ClearStateProductFilePage
  | GetFilesData
  | GetFilesDataSuccess
  | GetFilesDataFail;
